import React, { useEffect, useState } from "react";

import { BsCardChecklist, BsArrowRightShort, BsClockFill } from 'react-icons/bs';
import { FaVoteYea } from 'react-icons/fa';
import { MdTimerOff } from 'react-icons/md';

import Menu from '../Home/Menu';
import Footer from '../Home/Footer';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import './custom.css';
import { useWeb3React } from "@web3-react/core";
import GovernanceContract from '../getAbis/governance.json';
import Web3EthContract from "web3-eth-contract";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import formatDateAndtime from "../formatDateAndTime";
import { claimFund } from "./claim";
import { providerURL } from "../walletConnect/utils";

const Dao = () => {
  // Wallet Connection
  const {
    account,
    active, library
  } = useWeb3React();

  const [refresh, setRefresh] = useState(true);
  const [completed, setCompleted] = useState(false);
  const [proposalsAvailable, setProposalsAvailable] = useState(false);
  const [proposalList, setProposalList] = useState([]);

  useEffect(() => {
    getProposals()
  }, []);

  const getProposals = async () => {
    const { ethereum } = window;

    if (active) {
      Web3EthContract.setProvider(library.provider);
    } else {
      let provider = providerURL()
      Web3EthContract.setProvider(provider);
    }
    const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);

    let proposalCount = await governance_contract.methods.proposalCount().call();
    if (proposalCount != 0) {
      let countFinal = parseInt(proposalCount) + 1;
      setProposalsAvailable(true)
      for (let i = 1; i < countFinal; i++) {
        const readDocRef = doc(db, 'Proposals', `${i}`)
        const docSnap = await getDoc(readDocRef)

        console.log("doc exists ", docSnap.exists())



        const readDocRefProof = doc(db, "Proof", `${i}`);
        const docSnapProof = await getDoc(readDocRefProof);
        // if (docSnap.exists()) {
        //   getProposalsDetails(propNum, docSnap)
        // }
        // else {
        //   getProposalsDetails(propNum)
        //   setNoData(true)
        // }

        // const docRef = collection(db, 'Proposals')
        // const data = await getDocs(docRef)
        // let docSnap = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))

        let proposalData = await governance_contract.methods.proposals(i).call();
        let proposalStatus = await governance_contract.methods.state(i).call();

        console.log("data here ", docSnap)
        // if (docSnap.data().walletAddress == proposalData.proposer) {
        setProposalList(current => [...current, {
          key: i,
          "title": docSnap.data().title,
          "body": docSnap.data().description,
          "walletAddress": docSnap.data().walletAddress,
          "fundRequest": proposalData.fundRequest,
          "forVotes": proposalData.forVotes,
          "againstVotes": proposalData.againstVotes,
          "abstainVotes": proposalData.abstainVotes,
          "claimed": proposalData.claimed,
          "voters": proposalData.voters,
          "endDate": formatDateAndtime(new Date(proposalData.endTime * 1000)),
          "proposer": proposalData.proposer,
          "status": proposalStatus,
          "completed": docSnapProof.exists()
        }])
        // }
      }
    } else {
      setProposalsAvailable(false)
    }
  }

  return (
    <>
      <Menu />
      <section className="DAOSlider sliderSection">
        <div className="container">
          <div className="slideIn">
            <div className="row">
              <div className="col-sm-6">
                <div className="slideContent">
                  <h1>DAO</h1>
                  <p>Have your say in the future of the The Grays Ecosystem</p>
                  <div className="a_btns">
                    <a href="/proposal-create" ><BsCardChecklist /> Make a Proposal</a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="DaoMainSection padSection text-center">
        <div className="container">
          <h4 className="text-left text_high">Proposals</h4>
          <div className="single_cart">
            <Tabs defaultActiveKey="first">
              <Tab eventKey="first" title="All">
                {/* <div className="radios">
                  <input type="radio" id="Vote" value="Vote" /><label className="label" for="Vote">Vote Now</label>
                  <input type="radio" id="Soon" value="Soon" /><label className="label" for="Soon">Soon</label>
                  <input type="radio" id="Close" value="Close" /><label className="label" for="Close">Close</label>
                </div> */}
                <div className="multivotes text-left">
                  {proposalList.map((item, index) => {
                    // if (item.key == index) {
                    return (
                      <div className="sn_vote proposal-list" key={item.key}>
                        <h5>{item.title}</h5>
                        <p><b>Ends on : {item.endDate}</b></p>
                        <div className="a_btns">
                          {
                            item.status == 0 && !item.completed ?
                              <>
                                <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Vote Now</a>
                                {/* {account == item.walletAddress ?
                                  <>
                                    <button onClick={() => { claimFund(account, item.claimed, item.key) }} className="bg-success"> Claim</button>
                                    <a href={`/vote?proposal_id=${item.key}`} className="bg-danger"> Submit Proof</a>
                                  </>
                                  :
                                  <></>
                                } */}
                              </>
                              :
                              <>
                                {item.status == 1 && !item.completed ?
                                  <a href="#" className="closed"><MdTimerOff /> Defeated</a>
                                  :
                                  <>
                                    {item.status == 2 && !item.completed ?
                                      <>

                                        <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Succedded</a>
                                        {account == item.walletAddress ?
                                          <>
                                            <button onClick={() => { claimFund(account, item.claimed, item.key) }} className="bg-success"> Claim</button>
                                            <a href={`/vote?proposal_id=${item.key}`} className="bg-danger"> Submit Proof</a>
                                          </>
                                          :
                                          <></>
                                        }


                                      </>
                                      :
                                      <>
                                        <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Completed</a>

                                      </>
                                    }
                                  </>
                                }
                              </>
                          }
                        </div>
                        <div className="right_arrow"><a href={`/vote?proposal_id=${item.key}`}><BsArrowRightShort /></a></div>
                      </div>
                    )
                    // }
                  })}

                  {/* <div className="sn_vote">
                    <h5>Improvement Proposal For Perpetual Trading</h5>
                    <p><b>Ends Dec 12th, 2022 21:30</b></p>
                    <div className="a_btns">
                      <a href="/vote" ><FaVoteYea /> Vote Now</a>
                    </div>
                    <div className="right_arrow"><a href="#"><BsArrowRightShort /></a></div>
                  </div>
                  <div className="sn_vote">
                    <h5>Improvement Proposal For Perpetual Trading</h5>
                    <p><b>Ends Dec 12th, 2022 21:30</b></p>
                    <div className="a_btns">
                      <a href="#" className="soon" ><BsClockFill /> soon</a>
                    </div>
                    <div className="right_arrow"><a href="#"><BsArrowRightShort /></a></div>
                  </div>
                  <div className="sn_vote">
                    <h5>Improvement Proposal For Perpetual Trading</h5>
                    <p><b>Ends Dec 12th, 2022 21:30</b></p>
                    <div className="a_btns">
                      <a href="#" className="closed"><MdTimerOff /> closed</a>
                    </div>
                    <div className="right_arrow"><a href="#"><BsArrowRightShort /></a></div>
                  </div> */}
                </div>
              </Tab>

              <Tab eventKey="second" title="Active">
                <div className="multivotes text-left">
                  {proposalList.map((item, index) => {
                    if (item.status == 0) {
                      return (
                        <div className="sn_vote proposal-list" key={item.key}>
                          <h5>{item.title}</h5>
                          <p><b>Ends on : {item.endDate}</b></p>
                          <div className="a_btns">
                            <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Vote Now</a>
                          </div>
                          <div className="right_arrow"><a href={`/vote?proposal_id=${item.key}`}><BsArrowRightShort /></a></div>
                        </div>
                      )
                    }
                  })}
                </div>
              </Tab>

              <Tab eventKey="third" title="Succeedded">
                <div className="multivotes text-left">
                  {proposalList.map((item, index) => {
                    if (item.status == 2) {
                      return (
                        <div className="sn_vote proposal-list" key={item.key}>
                          <h5>{item.title}</h5>
                          <p><b>Ends on : {item.endDate}</b></p>
                          <div className="a_btns">
                            <a href={`/vote?proposal_id=${item.key}`} className="soon" ><FaVoteYea /> Succedded</a>
                            {account == item.walletAddress ?
                              <>
                                <button onClick={() => { claimFund(account, item.claimed, item.key) }} className="bg-success"> Claim</button>
                                <a href={`/vote?proposal_id=${item.key}`} className="bg-danger"> Submit Proof</a>
                              </>
                              :
                              <></>
                            }
                          </div>
                          <div className="right_arrow"><a href={`/vote?proposal_id=${item.key}`}><BsArrowRightShort /></a></div>
                        </div>
                      )
                    }
                  })}
                </div>
              </Tab>

              <Tab eventKey="fourth" title="Defeated">
                <div className="multivotes text-left">
                  {proposalList.map((item, index) => {
                    if (item.status == 1) {
                      return (
                        <div className="sn_vote proposal-list" key={item.key}>
                          <h5>{item.title}</h5>
                          <p><b>Ends on : {item.endDate}</b></p>
                          <div className="a_btns">
                            <a href={`/vote?proposal_id=${item.key}`} className="soon" ><BsClockFill /> Defeated</a>
                          </div>
                          <div className="right_arrow"><a href={`/vote?proposal_id=${item.key}`}><BsArrowRightShort /></a></div>
                        </div>
                      )
                    }
                  })}
                </div>
              </Tab>

              <Tab eventKey="sixth" title="Completed">
                <div className="multivotes text-left">
                  {proposalList.map((item, index) => {
                    if (item.completed) {
                      return (
                        <div className="sn_vote proposal-list" key={item.key}>
                          <h5>{item.title}</h5>
                          <p><b>Ends on : {item.endDate}</b></p>
                          <div className="a_btns">
                            <a href={`/vote?proposal_id=${item.key}`} className="soon" ><BsClockFill /> Completed</a>
                          </div>
                          <div className="right_arrow"><a href={`/vote?proposal_id=${item.key}`}><BsArrowRightShort /></a></div>
                        </div>
                      )
                    }
                  })}
                </div>
              </Tab>

              <Tab eventKey="fifth" title="Your Proposals">
                <div className="multivotes text-left">
                  {proposalList.map((item, index) => {
                    if (item.walletAddress == account) {
                      return (
                        <div className="sn_vote proposal-list" key={item.key}>
                          <h5>{item.title}</h5>
                          <p><b>Ends on : {item.endDate}</b></p>
                          <div className="a_btns">
                            {
                              item.status == 0 && !item.completed ?
                                <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Vote Now</a>
                                :
                                <>
                                  {item.status == 1 && !item.completed ?
                                    <a href="#" className="closed"><MdTimerOff /> Defeated</a>
                                    :
                                    <>
                                      {item.status == 2 && !item.completed ?
                                        <>
                                          <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Succedded</a>
                                          {account == item.walletAddress ?
                                            <>
                                              <button onClick={() => { claimFund(account, item.claimed, item.key) }} className="bg-success"> Claim</button>
                                              <a href={`/vote?proposal_id=${item.key}`} className="bg-danger"> Submit Proof</a>
                                            </>
                                            :
                                            <></>
                                          }
                                        </>
                                        :
                                        <>
                                          <a href={`/vote?proposal_id=${item.key}`} ><FaVoteYea /> Completed</a>

                                        </>
                                      }
                                    </>
                                  }
                                </>
                            }
                          </div>
                          <div className="right_arrow"><a href={`/vote?proposal_id=${item.key}`}><BsArrowRightShort /></a></div>
                        </div>
                      )
                    }
                  })}
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </section>
      <section className="HelpSection padSection text-center">
        <div className="container">
          <div className="single_cart">
            <h4>Got a suggestion?</h4>
            <p>proposals are a great way to see how the community feels about your ideas.</p>

            <p>They won't necessarily be implemented if the community votes successful, but suggestions with a lot of community support may be made into Core proposals.</p>
            <div className="a_btns">
              <a href="/proposal-create" ><BsCardChecklist /> Make a Proposal</a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default Dao;